import React, { useEffect, useState, useCallback } from "react";
// @ts-ignore
import ApiNames from "../constants/ApiNames";
import { useSearchParams, useNavigate } from "react-router-dom";
// @ts-ignore
import tagManagerEvents from "../utils/GoogleTagManager";
// @ts-ignore
import TagManager from "react-gtm-module";
// @ts-ignore
import {
  chekUser,
  checkOperator,
  loginSendOtp,
  sendOtp,
} from "../services/AuthService";
import { getEnrichment } from "../services/MiscService";
import Landing from "../components/Landing";

export interface LandingScreenProps {
  token?: string;
  loaderStatus?: (status: boolean) => void;
}

export interface ErrorState {
  Error: string;
  isTrue: boolean;
}

const LandingScreen: React.FC<LandingScreenProps> = (props) => {
  const [phNumber, setphNumber] = useState<string>("");
  const [error, setError] = useState<ErrorState>({ Error: "", isTrue: false });
  const [searchParams] = useSearchParams();
  const [heOtpFlag, setHeOtpFlag] = useState<boolean>(false);

  const utm_source = searchParams.get("utm_source") || "";
  const parameters = searchParams.get("parameter") || "";

  const [miniLoading, setMiniLoading] = useState<boolean>(false);
  const [userPackage] = useState<string>("");

  const navigate = useNavigate();

  const getHe = useCallback(async () => {
    try {
      const data = await getEnrichment(props.token);
      if (data && data.status === 200) {
        headerEnrichment(data);
      } else {
        console.log("Something went wrong");
      }
    } catch (error) {
      console.warn("get flow error subscription", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.token]);

  useEffect(() => {
    if (props.token) {
      getHe();
    }
  }, [props.token, getHe]);

  // Clear the global loading overlay once the landing screen is mounted
  // (its own button spinner is handled separately via `miniLoading`).
  useEffect(() => {
    props.loaderStatus?.(true);
  }, [props.loaderStatus]);

  const headerEnrichment = (data: any) => {
    try {
      if (data?.response?.msisdn === "") {
        tagManagerEvents("Wifi_User", utm_source);
      } else {
        tagManagerEvents("Data_User", utm_source);
        const msisdn = data?.response?.msisdn || "";
        setphNumber(msisdn.slice(2));
        setHeOtpFlag(true);
      }
    } catch (error) {
      console.log("Something went wrong");
    }
  };

  const onChangeMobileNumber = useCallback((value: string) => {
    setError({
      Error: "",
      isTrue: false,
    });

    if (value === "0" || !value.startsWith("3")) {
      setphNumber("");
    } else {
      const numRegex = new RegExp("^[0-9]*$");
      if (numRegex.test(value)) {
        setphNumber(value);
      }
    }
  }, []);

  const checkUserSubscription = useCallback(
    async (usrPackage: string) => {
      try {
        const response = await chekUser(phNumber, props.token);
        if (response && response.status === 200) {
          if (response.response?.desc?.toLowerCase() === "active") {
            sendWebOtp(phNumber, usrPackage, true);
          } else {
            const url =
              "https://services.jazz.com.pk/signin/JazzParho?ref=3&var=1&camp=JazzParho_Default";
            window.location.replace(url);
          }
        } else {
          setError({
            Error: "Something went wrong, Please try again later",
            isTrue: true,
          });
        }
      } catch (error) {
        setError({
          Error: "Something went wrong, Please try again later",
          isTrue: true,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [phNumber, props.token],
  );

  const checkOperatorStatus = useCallback(async () => {
    try {
      tagManagerEvents("Msisdn_Page", utm_source);
      setMiniLoading(true);
      const response = await checkOperator(phNumber, props.token);
      if (response && response.status === 200) {
        if (response.response?.operator?.toLowerCase() === "other") {
          setError({
            Error:
              "Service is only available for Jazz customers, kindly enter a working Jazz number",
            isTrue: true,
          });
          setMiniLoading(false);
        } else {
          checkUserSubscription(response.response?.package);
        }
      } else {
        setMiniLoading(false);
      }
    } catch (error) {
      setMiniLoading(false);
      console.log("Proceed Error ::", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phNumber, props.token, utm_source, checkUserSubscription]);

  const onClickProceed = useCallback(() => {
    if (heOtpFlag) {
      checkUserSubscription(userPackage);
    } else {
      checkOperatorStatus();
    }
  }, [heOtpFlag, userPackage, checkUserSubscription, checkOperatorStatus]);

  const sendWebOtp = async (
    num: string,
    usrPackage: string,
    isUserActive: boolean,
  ) => {
    try {
      setMiniLoading(true);
      let response: any;
      if (isUserActive) {
        response = await loginSendOtp(num, props.token);
      } else {
        response = await sendOtp(num, props.token);
      }
      if (
        response &&
        response.status === 200 &&
        response.response?.result === 0
      ) {
        setMiniLoading(false);
        tagManagerEvents("Request_OTP", utm_source);

        navigate("/pin", {
          state: {
            msisdn: num,
            utm_source: utm_source,
            parameters: parameters,
            userPackage: usrPackage,
            isUserActive: isUserActive,
            HeFlag: heOtpFlag ? response.response?.desc : null,
            uuid: response.response?.uuid,
          },
        });
      } else {
        setError({
          Error: "Something went wrong, Please try again later",
          isTrue: true,
        });
        setMiniLoading(false);
      }
    } catch (error) {
      setError({
        Error: "Something went wrong, Please try again later",
        isTrue: true,
      });
      setMiniLoading(false);
    }
  };

  const onHandleJoinNow = useCallback(() => {
    // setIsModel(false);
  }, []);

  return <></>;
};

export default LandingScreen;
